import script from "./Register.vue?vue&type=script&setup=true&name=staff&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&name=staff&lang=js"

import "./Register.vue?vue&type=style&index=0&id=2605ce34&lang=less&scoped=true"

import exportComponent from "G:\\Teamax\\雅丽洁支付\\yalgetoms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2605ce34"]])

export default __exports__